import { useLocation } from 'react-router-dom';
import { useRouteConfiguration } from '../context/routeConfigurationContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { parse } from '../util/urlHelpers';
import { createResourceLocatorString } from '../util/routes';

export const useKioskSearchSubmit = () => {
  const history = useHistory();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();

  return values => {
    const { keywords } = values || {};
    const currentParams = parse(location.search);

    const searchParams = {
      ...currentParams,
      keywords,
    };

    history.push(
      createResourceLocatorString('SearchPagePublished', routeConfiguration, {}, searchParams)
    );
  };
};
